import { Component, Input } from '@angular/core';

@Component({
  selector: 'oh-agent',
  templateUrl: './agent.component.html',
  styleUrls: ['./agent.component.scss'],
})
export class AgentComponent {
  @Input() info: any;

  constructor() {}
}
